import { select, put } from "redux-saga/effects";

import { getSchoolReceivedMessageIDList } from "state/teachers/selectors";
import { markMessagesRead } from "state/teachers/actions";

/**
 * Mark all received messages for the given school as read.
 */
export default function* markMessagesReadSaga(action) {
  const { schoolID } = action.payload;
  const messageIDList = yield select(getSchoolReceivedMessageIDList, schoolID);
  yield put(markMessagesRead(messageIDList));
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/markMessagesReadSaga.js